import { FetchStatus } from '@powdr/constants';

import { NODE_PENDING, NODE_SUCCESS, NODE_ERROR } from '../types';

const initialState = {
  node: {},
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NODE_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case NODE_SUCCESS:
      return {
        ...state,
        node: {
          ...state.node,
          ...action.payload,
        },
        status: FetchStatus.SUCCESS,
      };
    case NODE_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
